import { useState } from "react";
import LoginForm from "../../model/loginForm";
import { updateLoginForm, setRememberMe, setTerms } from "../providers/loginForm";

export function useLoginForm(): [LoginForm, Function, Function, Function] {
    const [state, setState] = useState({ name: "", password: "", error: "", rememberMe: false, terms: false });

    return [state,
        (name: string, value: string) => updateLoginForm(setState, name, value),
        (val: boolean) => setRememberMe(setState, val),
        (val: boolean) => setTerms(setState, val),
    ];
}
